<template>
    <div class="content" style="background-color: #fff;">
    	<form style="padding: .65rem .4rem;">
    		<van-row type="flex" class="from-item">
				<van-col span="6" class="textRight"><label><font color="red">*</font>机构名称：</label></van-col>
				<van-col span="18"><input type="text" name="" placeholder="请输入公司名称" /></van-col>
			</van-row>
			<van-row type="flex" class="from-item">
				<van-col span="6" class="textRight"><label><font color="red">*</font>手机号：</label></van-col>
				<van-col span="18"><input type="text" name="" placeholder="请输入手机号" /><span class="text-desc">手机号可直接登录销售保App</span></van-col>
			</van-row>
			<van-row type="flex" class="from-item">
				<van-col span="6" class="textRight"><label><font color="red">*</font>验证码：</label></van-col>
				<van-col span="10"><input type="text" name="" placeholder="请输入验证码" /></van-col>
				<van-col span="8"><button type="button" class="btn-getcode">获取验证码</button></van-col>
			</van-row>
			<van-row type="flex" class="from-item">
				<van-col span="6" class="textRight"><label><font color="red">*</font>密码：</label></van-col>
				<van-col span="18"><input type="text" name="" placeholder="请输入密码" /></van-col>
			</van-row>
			<van-row type="flex" class="from-item">
				<van-col span="6" class="textRight"><label>邀请人：</label></van-col>
				<van-col span="18"><input type="text" name="" placeholder="请输入邀请人手机号码" /></van-col>
			</van-row>
			<van-row type="flex" class="from-item"><span class="text-desc">注册即代表同意《销售保CRM用户协议》</span></van-row>
			<van-row type="flex" class="from-item" style="margin-top: 1.4rem;"><button type="button" class="btn-sumbit btn-full">注册并提交开户资料</button></van-row>
			<van-row type="flex" class="from-item"><a href="javascript:void(0)" style="color: #606266;font-size: .28rem;display: block;width: 100%;text-align: center;">公司已创建，直接提交开户资料 ></a></van-row>
    	</form>
    </div>
</template>
<script type="text/javascript">
	// import {getMsgCode,getGeetParm,applyTest} from '../api';
    export default {
        name: 'registerApply',
        data() {
            return {
                from:{}
            }
        },
        methods: {
            
        },
        mounted(){
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/register/registerApply.vue


// WEBPACK FOOTER //
// src/views/register/registerApply.vue